import Config from "../../config/index";

const initialState = {

    isLoggedIn: false,
    email: 'info@awave.se',
    id: null,
    guid: null,
    userName: "",
    userId: "",
    firstName: null,
    lastName: null,
    jobTitle: '',
    role: "",
    loginFailed: false,
    ssoGetTokenLoading: false,
    ssoGetTokenFailed: false,
    ssoToken: "",
    ssoFailedCounter: 0,

    loading: false,
    submitting: false,
    serverDown: false,
};

export default (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {

        case "USER_RESET":
            return initialState;

        case 'USER_SET_ROLE':

            let roleId = 0;
            switch (payload) {
                case "Hrbp":
                case "hrbp":
                    roleId = 4;
                    break;
                case "manager":
                    roleId = 2;
                    break;
                case "admin":
                    roleId = 3;
                    break;
                default:
                    roleId = 1;
                    break;
            }
            Config.setRole(roleId);
            state = {
                ...state,
                role: payload
            };
            return state;

        case 'USER_LOGIN_SUBMITTING':
            state = {
                ...state,
                submitting: true,
                serverDown: false
            };
            return state;

        case 'USER_LOGIN_SUCCESS':
            state = {
                ...state,
                userName: payload.userName,
                userId: payload.userId,
                guid: payload.guid,
                isLoggedIn: true,
                submitting: false,
                loading: false,
                loginFailed: false,
                serverDown: false,
                ...payload
            };
            return state;

        case 'USER_LOGIN_FAILURE':
            state = {
                ...initialState,
                username: "",
                userId: "",
                isLoggedIn: false,
                submitting: false,
                loading: false,
                loginFailed: true
            };
            return state;

        case "USER_SET_ACTION_KEYWORD":
            state = {
                ...state,
                actionSearchKeyword: payload
            };
            return state;

        case 'USER_LOADING':
            state = {
                ...state,
                loading: true
            }
            return state;

        case 'USER_SINGLE_SUCCESS':

            Config.setUser({
                guid: payload.guid,
                userId: payload.userId,
                userName: payload.username,
            });

            state = {
                ...state,
                ...payload,
                manager: null,
                ongoingActions: null,
                actionGroups: null,
                loading: false,
                manageAs: null,
                managers: null
            }
            return state;

        case 'USER_SINGLE_FAILURE':
            state = {
                ...state,
                manager: null,
                ongoingActions: null,
                actionGroups: null,
                loading: false
            };
            return state;

        case 'USER_GET_MANAGER':
            state = {
                ...state,
                manager: payload
            };
            return state;

        case 'USER_GET_ACTIONS':
            state = {
                ...state,
                actionGroups: payload
            };
            return state;

        case 'USER_GET_ONGOING_ACTIONS':
            state = {
                ...state,
                ongoingActions: payload
            };
            return state;

        case 'USER_FORMS_SUBMISSION_INPROGRESS':
            state = {
                ...state,
                submitting: true
            };
            return state;

        case 'USER_FORMS_SUBMISSION_FINISHED':
            state = {
                ...state,
                submitting: false
            };
            return state;

        case 'USER_FORMS_EXIT_ACTION':
            let ongoingActions = state.ongoingActions;
            let newSubmission = payload;
            let lastElement = state.ongoingActions[state.ongoingActions.length - 1];

            if (newSubmission.id) {
                for (let x in ongoingActions) {
                    if (ongoingActions[x].id === newSubmission.id) {
                        ongoingActions[x] = newSubmission;
                    }
                }
            } else {
                newSubmission.id = lastElement.id + 1;
                ongoingActions.push(newSubmission);
            }

            state = {
                ...state,
                submitting: false,
                ongoingActions: ongoingActions
            };
            return state;

        case 'USER_GET_ALL_USERS':
            state = {
                ...state,
                users: payload
            }
            return state;


        //---SSO-TOKEN
        case "SSO_GET_TOKEN_LOADING":
            state = {
                ...state,
                ssoGetTokenLoading: true,
                ssoTest: false,
                ssoGetTokenFailed: false
            };
            return state;

        case "SSO_GET_TOKEN_SUCCESS":
            state = {
                ...state,
                ssoGetTokenLoading: false,
                ssoToken: payload,
                ssoGetTokenFailed: false,
                ssoFailedCounter: 0,
            };
            return state;

        case "SSO_GET_TOKEN_FAILURE":
            state = {
                ...state,
                ssoGetTokenLoading: false,
                ssoGetTokenFailed: true,
                ssoToken: false,
                ssoFailedCounter: state.ssoFailedCounter + 1,
            };
            return state;

        case "SERVER_DOWN":
            state = {
                ...state,
                serverDown: true,
            };
            return state;

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/user.js